import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Box,
  Container,
  Stack,
  IconButton,
  MenuItem,
  alpha,
  Menu,
  styled,
  LinearProgress,
} from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { getAuth } from 'firebase/auth';
import { UserAuth } from '../../../../context/AuthContext';
import { useSnackbar } from '../../../../context/snackbarContext';
import { db } from '../../../../firebase.config';
import Page from '../../../../components/Page';
import CustomButton from '../../../../components/CustomButton';
import Sum from './components/showCampaignComponent/sum';
import Perfs from './components/showCampaignComponent/perfs';
import LucideIcon from '../../../../components/LucideIcon';
import PerfsV2 from './components/showCampaignComponent/perfv2';
import SumV2 from './components/showCampaignComponent/sumV2';
import CustomModal from '../../../../components/customModal/customModal';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 5,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

const EmailCampaignDashboard = () => {

  const { campaignID } = useParams();
  const { user, userData } = UserAuth();
  const showSnackbar = useSnackbar()
  const navigate = useNavigate()
  const [mailContent, setMailContent] = useState();
  const [event, setEvent] = useState();

  const [fbCampagneData, setFbCampagneData] = useState();

  const [loading, setLoading] = useState(false);


  const [type, setType] = useState(0);

  // 🎯 Suggestion automatique
  const getSuggestion = () => {


  };

  const suggestion = getSuggestion();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [campagneType, setCampagneType] = React.useState(1);
  const [replyTo, setReplyTo] = React.useState();
  const [recever, setRecever] = React.useState();
  const [object, setObject] = React.useState();
  const [audience, setAudience] = React.useState(1);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);
const [duplicating, setDuplicating] = useState(false);

const handleConfirmDuplicate = async () => {
  try {
    setDuplicating(true)
    const auth = getAuth();
    const token = await auth.currentUser.getIdToken();

    // ⚠️ Remplace l’URL par l’URL déployée de ta Cloud Function
    // Ex: https://europe-west1-<PROJECT_ID>.cloudfunctions.net/duplicateCampaign
    const CF_URL = "https://us-central1-event-86cbf.cloudfunctions.net/duplicateCampaign";

    const resp = await fetch(CF_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ campaignId: campaignID }),
    });

    const json = await resp.json();
    console.log(json)
    if (!resp.ok) throw new Error(json.error || "Duplication échouée");

    showSnackbar("Campagne dupliquée avec succès 🎉", false);
    // redirige vers la nouvelle campagne (édition)
    navigate(`/marketing/campaigns/${json.newCampaignId}`, { replace: true });
  } catch (e) {
    console.error(e);
    showSnackbar(e.message || "Erreur lors de la duplication", true);
  } finally {
    setDuplicating(false)
  }
}


  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        console.log(userData)
        if (userData === null) {
          return
        }
        const docRefCampaign = doc(db, `campagnes`, `${campaignID}`);
        const docSnapCampaign = await getDoc(docRefCampaign);
        if (docSnapCampaign.exists()) {
          setFbCampagneData(docSnapCampaign.data())
          console.log(docSnapCampaign.data())
          setObject(docSnapCampaign.data()?.object)
          setAudience(docSnapCampaign.data()?.audiences)
          setCampagneType(docSnapCampaign.data()?.campagneType)
          setRecever(docSnapCampaign.data()?.audienceType)
          setReplyTo(docSnapCampaign.data()?.sender)
          const docMailContentRef = doc(db, `organisations/${userData.idOrg}/crm/${userData.idOrg}/campagneTemplates`, campaignID)
          const docMailContentSnap = await getDoc(docMailContentRef);
          if (docMailContentSnap.exists()) {
            setMailContent(docMailContentSnap)
            // setHtmlContent(docMailContentSnap.data()?.html)
          }
          if (docSnapCampaign.data()?.eventID) {
            const eventRef = doc(db, `evenement`, docSnapCampaign.data()?.eventID)
            const eventSnap = await getDoc(eventRef);
            if (eventSnap.exists()) {
              setEvent(eventSnap.data())
              // setHtmlContent(docMailContentSnap.data()?.html)
            }
          }

        }
        // recupération de event


        setLoading(false);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    })();
  }, [campaignID, userData]);

  return (
    <Page title="Campagne">
      <Container sx={{ padding: 2, bgcolor: 'white' }}>
        {
          duplicating || loading && <LinearProgress />
        }
        <Stack spacing={2} direction={'column'} alignItems={'start'} sx={{ width: '100%' }}>
         
          <Stack spacing={2} sx={{ paddingY: 0, borderRadius: '10px', width: '100%' }}>
            <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'space-between'}>
              <Stack direction={'row'} spacing={2} >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CustomButton onClick={() => navigate(-1)} buttonText={null} type={'back'} />
                </Box>
                  
                <Stack direction={'column'}>
                  <Typography variant="h4">{fbCampagneData?.name}</Typography>
                  <Stack direction={'row'} spacing={0.5}>
                    <Typography variant="caption">creé par {fbCampagneData?.name}</Typography>
                    <LucideIcon name='Dot' />
                    <Typography variant="caption">Publié le <strong>12 juillet 2025</strong></Typography>
                  </Stack>

                </Stack>

              </Stack>

              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={openMenu ? 'long-menu' : undefined}
                aria-expanded={openMenu ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleOpenMenu(e)}
                sx={{ border: '1px solid gainsboro' }}
              >
                <LucideIcon name='EllipsisVertical' />
              </IconButton>

              <StyledMenu
                id="long-menu"
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleCloseMenu}
              >
                
                {
                  <MenuItem onClick={() => {
                    handleCloseMenu();
                    // handleOpenPlanifiedModal(selectedIndex);
                    // setOpenPlanifiedDialog(true); // Utilise l'index sélectionné
                  }} disableRipple value={2}>
                    <Typography variant='body1'>Modifier la planification</Typography>
                  </MenuItem>
                }
              

                <MenuItem onClick={() => {
                  setOpenDuplicateDialog(true)
                  handleCloseMenu();
                  // setOpenDeleteDialog(true); // Utilise l'index sélectionné
                }} disableRipple value={4}>
                  <Typography variant='body1'>Dupliquer la campagne</Typography>
                </MenuItem>

                <MenuItem onClick={() => {
                  handleCloseMenu();
                  // setOpenDeleteDialog(true); // Utilise l'index sélectionné
                }} disableRipple value={5}>
                  <Typography variant='body1'>Supprimer</Typography>
                </MenuItem>
              </StyledMenu>
            </Stack>
          </Stack>

          <Stack my={2} direction='row' spacing={1}>
            <Box onClick={() => {
              setType(0)

            }} sx={type === 0 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
              :
              { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={1.5} paddingY={1} >
              <Typography variant='caption'>Details</Typography>
            </Box>
            <Box onClick={() => {
              setType(1)

            }} sx={type === 1 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
              :
              { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={1.5} paddingY={1} >
              <Typography variant='caption'>Perfommance</Typography>
            </Box>
          </Stack>
          
          {/** <Sum campagnId={campaignID} mailContent={mailContent} email={replyTo} audience={audience} recever={fbCampagneData?.audienceType} campagnData={fbCampagneData} subject={object} />
             */}
          {
            type === 0 ?
              <SumV2 mailContent={mailContent} campagnData={fbCampagneData}/>
               : <PerfsV2 campaignId={campaignID} />
          }
        </Stack>
        <CustomModal
  open={openDuplicateDialog}
  onClose={() => setOpenDuplicateDialog(false)}
  onConfirm={handleConfirmDuplicate}
  loading={duplicating}
  title="Dupliquer la campagne ?"
  confirmText="Oui, dupliquer"
  cancelText="Annuler"
  description={
    <>
      <Typography variant="body2" paragraph>
        Cette action crée une <strong>nouvelle campagne</strong>
      </Typography>
      <Typography variant="body2">
        Les <strong>statistiques</strong> ne sont <strong>pas</strong> copiées. Le statut de la nouvelle campagne sera <strong>brouillon</strong> afin que vous puissiez la lancer vous-même.
      </Typography>
    </>
  }
/>


      </Container>

    </Page>

  );
};
export default EmailCampaignDashboard;